import type { PaymentMethodIconGlyph } from '@sunwebgroup/uds-ui/payment-method-icon'
import type { BrandName } from '@/scopes/common/domain/types'

export type PaymentMethod =
  'alma'
  | 'americanexpress'
  | 'amex'
  | 'ancv'
  | 'bancontact'
  | 'bcmc'
  | 'bcmc_mobile'
  | 'banktransfer'
  | 'cartesbancaires'
  | 'dankort'
  | 'dinersclub'
  | 'discover'
  | 'giropay'
  | 'ideal'
  | 'jcb'
  | 'kbc'
  | 'klarna'
  | 'klarna_account'
  | 'mastercard'
  | 'mc'
  | 'creditcard'
  | 'mobilepay'
  | 'paybybank'
  | 'paypal'
  | 'swish'
  | 'trustly'
  | 'unionpay'
  | 'visa'
  | 'voucher'

export function mapPaymentMethodToGlyph(
  method: PaymentMethod,
  brandName?: BrandName,
): PaymentMethodIconGlyph | undefined {
  switch (method) {
    case 'alma':
      return 'IconAlmaOnCard'
    case 'ancv':
      return 'IconAncv'
    case 'bancontact':
      return 'IconBancontact'
    case 'bcmc':
      return 'IconBancontactCard'
    case 'bcmc_mobile':
      return 'IconBancontactPay'
    case 'banktransfer':
      return 'IconBankTransfer'
    case 'cartesbancaires':
      return 'IconCartesBancaires'
    case 'dankort':
      return 'IconDankort'
    case 'dinersclub':
      return 'IconDinersClub'
    case 'discover':
      return 'IconDiscover'
    case 'giropay':
      return 'IconGiropay'
    case 'ideal':
      return 'IconIdeal'
    case 'jcb':
      return 'IconJcb'
    case 'kbc':
      return 'IconKbc'
    case 'klarna':
    case 'klarna_account':
      return 'IconKlarnaOnCard'
    case 'mastercard':
    case 'mc':
      return 'IconMastercard'
    case 'creditcard':
      return 'IconMastercardAndVisaOnCard'
    case 'mobilepay':
      return 'IconMobilepay'
    case 'paybybank':
      return 'IconPaybybank'
    case 'paypal':
      return 'IconPaypal'
    case 'swish':
      return 'IconSwish'
    case 'trustly':
      return 'IconTrustly'
    case 'unionpay':
      return 'IconUnionpay'
    case 'visa':
      return 'IconVisa'
    case 'voucher':
      return brandName === 'eliza' ? 'IconVoucherEliza' : 'IconVoucher'
    default:
      return undefined
  }
}
